import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";

import Sidebar from "./COMPONENTES/Hiddensidebar";
import Header from "./COMPONENTES/Header";
import Login from "./COMPONENTES/Login";
import Clientes from "./COMPONENTES/Clientes";
import MAIN_Content from "./COMPONENTES/Main_content";
import CrearCliente from "./COMPONENTES/CrearCliente";
import CRMDashboard from "./COMPONENTES/Pantalla_inicio";
import Prestamos from "./COMPONENTES/Prestamos";
import CrearPrestamo from "./COMPONENTES/CrearPrestamo";
import Pagos from "./COMPONENTES/Pagos";

import './App.css';
import { CatalogosProvider } from "./CONTEXTO/CatalogosContext";

export default function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const isLoginPage = location.pathname.toLowerCase().includes("/login");

  const handleLogout = () => {
    setSidebarOpen(false);
    navigate("/login");
  };

  return (
    <CatalogosProvider>
      {isLoginPage ? (
        <Login />
      ) : (
        <div className="app-container">

          <Header onLogout={handleLogout} />

          <Sidebar 
            isOpen={sidebarOpen}
            setIsOpen={setSidebarOpen}
          />

          <main className={`main-scrollable ${sidebarOpen ? "shifted" : ""}`}>
            <div className="content-box">
              <Routes>
                <Route path="/" element={<Navigate to="/login" replace />} />
                <Route path="/login" element={<Login />} />
                <Route path="/inicio" element={<CRMDashboard />} />
                <Route path="/prestamos" element={<Prestamos />} />
                <Route path="/prestamos/crear" element={<CrearPrestamo />} />
                <Route path="/clientes" element={<Clientes />} />
                <Route path="/clientes/crear" element={<CrearCliente mode="create" />} />
                <Route path="/clientes/:id" element={<CrearCliente mode="view" />} />
                <Route path="/clientes/:id/editar" element={<CrearCliente mode="edit" />} />
                <Route path="/pagos" element={<Pagos />} />
                <Route path="/recuperaciones" element={<MAIN_Content />} />
                <Route path="/reportes" element={<MAIN_Content />} />
                <Route path="/configuracion" element={<MAIN_Content />} />
              </Routes>
            </div>
          </main>

        </div>
      )}
    </CatalogosProvider>
  );
}
